import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';

export const HAS_PROJECTS_QUERY = gql`
  query HasProjects($filter: ProjectFilter2) {
    projects(page: 1, pagesize: 1, projectFilter: $filter) {
      id
    }
  }
`;

export const useHasProjects = ({ filter, skip = false }) => {
  const { data, loading } = useQuery(HAS_PROJECTS_QUERY, {
    fetchPolicy: 'network-only',
    skip,
    variables: {
      filter
    }
  });

  const projects = get(data, 'projects', []);

  return {
    hasProjects: projects.length > 0,
    loading
  };
};

export default useHasProjects;
